// Attendance: its lists that open by address, and the count printed on each list's card.
// No React in here.
//
// Both lists come from ONE answer, the absentees call:
//   • Absent Today: shift start has passed, no check-in, no leave. It is not "everyone
//     absent" (a person whose shift start is not known is left out).
//   • Continuously Absent: a current run of two or more absent days. A run is counted in
//     working days: week offs and holidays neither break it nor add to it.
//
// The trend and the attendance map follow the Month picker; these two lists are always
// today's.
import type { DashboardListInfo } from './types';

export const ATTENDANCE_LIST = { absentToday: 'absent-today', continuous: 'continuously-absent' } as const;

export const LISTS: DashboardListInfo[] = [
  { slug: ATTENDANCE_LIST.absentToday, name: 'Absent Today', line: 'Shift start has passed, no check-in, no leave.', keywords: 'not turned up no show missing today' },
  { slug: ATTENDANCE_LIST.continuous, name: 'Continuously Absent', line: 'A current run of two or more absent days in a row.', keywords: 'absent for days missing in a row' },
];

/** The part of the absentees answer the counts are read from. */
export interface AbsenteesAnswer {
  absentToday: { total: number; rows: unknown[] };
  continuous: { total: number; rows: unknown[] };
}

export interface AbsentCounts {
  /** People on Absent Today. */
  absentToday: number | null;
  /** People on Continuously Absent. */
  continuous: number | null;
}

const NOT_LOADED: AbsentCounts = { absentToday: null, continuous: null };

// A list's count is its total only while that is also how many rows the pop-up will show.
// If the two ever part (an answer that sends fewer rows than it counted), the count is
// withheld rather than printed beside a list that does not add up to it.
const listCount = (list: { total: number; rows: unknown[] } | undefined): number | null =>
  list && Array.isArray(list.rows) && list.total === list.rows.length ? list.total : null;

/**
 * The counts, read from the absentees answer. Pass null while it is on its way or after
 * it failed: every count is then null, which is "not known", never zero.
 */
export function readAbsentCounts(answer: AbsenteesAnswer | null): AbsentCounts {
  if (!answer) return NOT_LOADED;
  return { absentToday: listCount(answer.absentToday), continuous: listCount(answer.continuous) };
}
